<template>
  <v-dialog persistent v-model="dialog" width="600">
    <v-card raised class="card-dialog-confirmar-lotes" height="auto">
      <v-layout justify-center>
        <v-flex lg12 class="ma-2 mt-10 ml-7">
          <span
            v-if="window == 'lotes'"
            class="titulo-dialog-confirmar-lotes"
          >Confirmar Alocação de Lotes</span>
          <span
            v-else-if="window == 'programacao'"
            class="titulo-dialog-confirmar-lotes"
          >Confirmar Programação</span>
          <span
            v-else-if="window == 'carregamento'"
            class="titulo-dialog-confirmar-lotes"
          >Confirmar Turnos</span>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex lg12 class="ma-2 ml-8 mr-8 d-flex flex-column">
          <span
            v-if="window == 'lotes'"
            class="text-dialog-confirmar-lotes"
          >Ao confirmar, os produtores serão notificados que estão previstos na programação de carregamento e receberão os checklists para preenchimento.</span>
          <span
            v-else-if="window == 'programacao'"
            class="text-dialog-confirmar-lotes"
          >Ao confirmar, os produtores serão notificados que foram confirmados na programação de carregamento.</span>
          <span
            v-else-if="window == 'carregamento'"
            class="text-dialog-confirmar-lotes"
          >Ao confirmar, os produtores serão notificados do turno de abate, carregamento e início de jejum pré abate.</span>
          <v-row v-if="window === 'lotes'" class="ma-0 pt-2">
            <div
              v-show="textBiggerThanDemand"
              v-html="textBiggerThanDemand"
              class="d-flex flex-column"
            />
            <span v-show="textBiggerThanDemand" class="error--text">Confirmar mesmo assim?</span>
          </v-row>
        </v-flex>
      </v-layout>

      <v-layout pr-8 pl-8 pt-5 pb-5>
        <v-layout row wrap justify-start>
          <v-btn
            class="button-cancelar-confirmar-lotes"
            color="#E5E8E7"
            @click="cancelarConfirmacao"
          >
            <span class="text-buttton-cancelar-confirmar-lotes">Cancelar</span>
          </v-btn>
          <v-spacer />
          <v-btn
            class="button-confirmar-lotes"
            color="#2bc1b6"
            @click="confirmarLotes"
            :loading="loading"
          >
            <span v-if="window != 'lotes'" class="text-button-confirmar-lotes">Confirmar</span>
            <span v-else class="text-button-confirmar-lotes">Confirmar Previsão</span>
          </v-btn>
        </v-layout>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { SlaughterProgrammingStepsEventBus } from "@/modules/programacaoAbate/events";
import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    textBiggerThanDemand() {
      let bigger = false;
      let smaller = false;
      const acc = {};
      this.listBatchsAllocated.forEach((loteAlocado) => {
        if (!acc[loteAlocado.cdPlantaAbate])
          acc[loteAlocado.cdPlantaAbate] = {};
        if (!acc[loteAlocado.cdPlantaAbate][loteAlocado.stDiaAlocado])
          acc[loteAlocado.cdPlantaAbate][loteAlocado.stDiaAlocado] = 0;
        if (!loteAlocado.blDeleted)
          acc[loteAlocado.cdPlantaAbate][loteAlocado.stDiaAlocado] +=
            parseInt(loteAlocado.qtAnimaisAlocados) || 0;
      });

      this.listaDemandasPlanta.forEach((item) => {
        if (!acc[item.cdPlantaAbate]) return;
        this.listDatesWithDemand.forEach((date) => {
          if (!acc[item.cdPlantaAbate][date.value]) return;
          if (acc[item.cdPlantaAbate][date.value] > item[date.value])
            bigger = true;
          else if (acc[item.cdPlantaAbate][date.value] < item[date.value])
            smaller = true;
        });
      });

      let textHtml = "";
      if (bigger)
        textHtml =
          "<span class='error--text'>Há lotes com a quantidade de animais alocados maior que a demanda prevista.</span>";
      if (smaller)
        textHtml +=
          "<span class='error--text'>Há lotes com a quantidade de animais alocados menor que a demanda prevista.</span>";
      return textHtml;
    },
    ...mapState("programacaoAbate", [
      "listBatchsAllocated",
      "listaDemandasPlanta",
      "listDatesWithDemand",
      "loading",
    ]),
  },
  data() {
    return {};
  },
  methods: {
    cancelarConfirmacao() {
      this.$emit("cancelarConfirmacao");
    },
    confirmarLotes() {
      if (this.window == "lotes") {
        this.$emit("sendConfirmarLotes");
      } else if (this.window == "programacao") {
        this.$emit("sendConfirmarProgramacao");
        SlaughterProgrammingStepsEventBus.$emit("set-step", 4);
      } else if (this.window == "carregamento") {
        this.$emit("sendConfirmarCarregamento");
        SlaughterProgrammingStepsEventBus.$emit("set-step", 0);
      }
    },
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    window: {
      type: String,
      default: "",
    },
    heightTotal: {
      type: Number,
      default: 300,
    },
  },
};
</script>

<style lang="scss">
.card-dialog-confirmar-lotes {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 56px #10303d29;
  border-radius: 8px;
  opacity: 1;
}

.text-button-confirmar-lotes {
  text-align: right;
  font: normal 16px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.button-confirmar-lotes {
  background: #2bc1b6 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.text-buttton-cancelar-confirmar-lotes {
  text-align: center;
  font: normal 16px/21px Roboto;
  letter-spacing: 0px;
  color: #7b9596;
  opacity: 1;
}

.button-cancelar-confirmar-lotes {
  border: 1px solid #e5e8e7;
  border-radius: 4px;
  opacity: 1;
}

.titulo-dialog-confirmar-lotes {
  text-align: center;
  font: bold 24px Roboto;
  letter-spacing: 0px;
  color: #37565c;
  opacity: 1;
}

.text-dialog-confirmar-lotes {
  text-align: left;
  font: normal 16px Roboto;
  letter-spacing: 0px;
  color: #37565c;
  opacity: 1;
}
</style>